/**
 * Builds the export query for a list, merging filter params with list constraints.
 * Ensures the list constraint is always present, even if listContactIdQuery hasn't loaded yet.
 *
 * @param {Object} params
 * @param {Object|null} params.filterParams - Active filter parameters from FilterStore
 * @param {Object|null} params.listContactIdQuery - Query with contact IDs from GraphQL (has `must` array)
 * @param {string|number} params.listId - The list ID to use as fallback constraint
 * @returns {Object} The merged query with both filters and list constraint
 */
export const buildListExportQuery = ({ filterParams, listContactIdQuery, listId }) => {
  // Build the list constraint - prefer listContactIdQuery if loaded, otherwise use list_memberships fallback
  const listConstraint =
    listContactIdQuery && listContactIdQuery.must
      ? listContactIdQuery.must
      : [{ 'list_memberships.list_id': { match: listId } }];

  if (!filterParams || Object.keys(filterParams).length === 0) {
    // No filters active, just use list constraint
    return { must: [...listConstraint] };
  }

  // Both filters and list constraint exist - merge them immutably
  return {
    ...filterParams,
    must: [...(filterParams.must || []), ...listConstraint],
  };
};
